<div *ngIf="data.show"  class="context-menu-container" [style.left.px]="data.x" [style.top.px]="data.y">
  <div class="context-menu-name">{{data.data.name}}</div>
  <div  class="context-menu-item" *ngFor="let item of data.option" 
        [style.--color]="item?.color"
        [style.--hover-color]="item?.hover?.color" 
        (click)="select(item?.key)">
    {{item.label}}
  </div>
</div>